export const VIEW_CONSENT = 'VIEW_CONSENT';
export const VIEW_CONSENT_FAILED = 'VIEW_CONSENT_FAILED';
